module.exports = __webpack_public_path__ + "img/ae.193946fd.svg";